<template>
  <div class="role-bd bd" :class="{ 'crm-role': !!orgId }">
    <div class="aside" @mousedown="dragStart" @mousemove="dragMove" @mouseup="dragEnd">
      <div class="ub-f1 ubv org-role">
        <div class="title">
          <i class="icon icon-zuzhi"></i>
          <span>{{ $t('base_role.gang_wei') }}</span>
        </div>
        <div class="search">
          <div class="ub">
            <div class="ub-f1">
              <el-input :placeholder="$t('base_role.gang_wei_ming_cheng')" style="width: 100%" v-model="appKey" @input="filterTree"></el-input>
            </div>
            <div v-if="funcView.role_add || !!orgId" style="margin-left: 10px">
              <el-button type="primary" icon="el-icon-plus" @click="addRole()">{{ $t('Common.com_add') }}</el-button>
            </div>
          </div>
        </div>
        <div class="list">
          <el-tree
            ref="tree"
            :data="roleList"
            :props="treeProps"
            node-key="roleId"
            :highlight-current="true"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
          >
            <span v-if="data.roleId === roleData.roleId" class="tree-item" slot-scope="{ data }">
              <span class="line1" :class="{ disable: !data.state }">{{ data.roleName }}</span>
              <span>
                <el-button v-if="funcView.role_add || !!orgId" type="text" @click.stop="editRole(data)" size="mini">
                  <i class="icon icon-bianji"></i>
                </el-button>
                <el-button v-if="funcView.role_delete || !!orgId" type="text" @click.stop="deleteRole(data)" size="mini">
                  <i class="icon icon-shanchu"></i>
                </el-button>
                <el-button type="text" v-if="data.state && (funcView.role_disable || !!orgId)" @click.stop="changeStateRole(data)" size="mini">
                  <i class="icon icon-jinyong1"></i>
                </el-button>
                <el-button type="text" v-if="!data.state && (funcView.role_enable || !!orgId)" @click.stop="changeStateRole(data)" size="mini">
                  <i class="icon icon-qiyong"></i>
                </el-button>
              </span>
            </span>
            <span class="tree-item" v-else>
              <span class="line1" :class="{ disable: !data.state }">{{ data.roleName }}</span>
            </span>
          </el-tree>
        </div>
      </div>
      <div v-if="!isAdmin" class="sys-user" id="sys-user" :style="{ height: sysUserH }">
        <div class="bar drag">
          <div class="bar-box center drag">
            <div class="drag"></div>
            <div class="drag"></div>
          </div>
        </div>
        <div class="title">
          <i style="font-size: 18px" class="icon icon-zuzhi1"></i>
          <span>{{ $t('base_role.xi_tong_jue_se') }}</span>
        </div>
        <div class="list">
          <el-tree ref="tree2" :data="sysRoleList" :props="treeProps" node-key="roleId" :highlight-current="true" :expand-on-click-node="false" @node-click="handleNodeClick">
            <span v-if="data.roleId === roleData.roleId" class="tree-item" slot-scope="{ data }">
              <span class="line1" :class="{ disable: !data.state }">{{ data.roleName }}</span>
            </span>
            <span class="tree-item" v-else>
              <span class="line1" :class="{ disable: !data.state }">{{ data.roleName }}</span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <div class="section" style="padding: 0">
      <custom-tab v-model="activeTab" :list="tabData"></custom-tab>
      <!-- 功能权限 -->
      <role-permission v-if="activeTab === 'funcRole'" :roleId="roleData.roleId" :orgId="orgId"></role-permission>
      <!-- 分配角色 -->
      <role-user v-if="activeTab === 'employeeList'" :roleId="roleData.roleId" :orgId="orgId"></role-user>
      <!-- 业务审批 -->
      <bus-aduit v-if="activeTab === 'busAudit'" :roleId="roleData.roleId" :orgId="orgId"></bus-aduit>
      <!-- 消息列表 -->
      <msg-list v-if="activeTab === 'msgList'" :roleId="roleData.roleId" :orgId="orgId"></msg-list>
    </div>
    <!-- 新增角色弹窗 -->
    <role-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getRoleList"></role-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import rolePermission from '@/pages/base/components/rolePermission.vue';
import roleDialog from '@/pages/base/components/roleDialog.vue';
import roleUser from './children/role_user.vue';
import busAduit from './children/bus_aduit.vue';
import msgList from './children/msg_list.vue';

export default {
  name: 'role',
  components: { roleDialog, rolePermission, roleUser, busAduit, msgList },
  props: {
    orgId: [String, Number],
  },
  data() {
    return {
      activeTab: 'funcRole',
      treeProps: {
        children: 'children',
        label: 'roleName',
      },
      roleList: [],
      roleData: {},
      appKey: '',
      dialogVisible: false,
      dialogModel: {},
      startY: 0,
      moveY: 0,
      containerH: 200,
      hasDrag: false,
      sysRoleList: [],
      dicMap: {},
      isAdmin: false,
      userInfo: {},
    };
  },
  computed: {
    sysUserH() {
      return `${this.containerH + this.startY - this.moveY}px`;
    },
    tabData() {
      const map = this.dicMap.bas_role_type;
      const user = {
        name: this.$t('base_role.yuan_gong'), // 员工列表
        value: 'employeeList',
      };

      const msg = {
        name: this.$t('base_role.xiao_xi'), // 消息列表
        value: 'msgList',
      };

      const funcRole = {
        name: this.$t('base_role.quan_xian'), // 功能权限
        value: 'funcRole',
      };

      const employeeList = {
        name: this.$t('base_role.yuan_gong'), // 员工列表
        value: 'employeeList',
      };

      const busAudit = {
        name: this.$t('base_role.shen_pi'), // 业务审批
        value: 'busAudit',
      };

      const defaultData = [funcRole, employeeList];

      if (this.isAdmin) {
        return defaultData;
      }
      if (this.roleData.roleId && map) {
        // notice_role  员工列表，消息列表
        if (this.roleData.roleType === map.notice_role) {
          const ret = [];

          if (this.funcView.role_user || !!this.orgId) {
            ret.push(user);
          }

          if (this.funcView.role_msg || !!this.orgId) {
            ret.push(msg);
          }

          return ret;
        }
        // service_role 功能权限，员工列表，业务审批
        if (this.roleData.roleType === map.service_role) {
          const ret = [];
          // if (this.funcView.role_list) {
          //   ret.push(funcRole);
          // }
          if (this.funcView.role_user || !!this.orgId) {
            ret.push(employeeList);
          }
          if (this.funcView.role_bus || !!this.orgId) {
            ret.push(busAudit);
          }
          return ret;
        }
        // 其他 功能权限  员工列表
        return defaultData;
      }
      return [];
    },
  },
  mounted() {
    this.getFuncView('/company/role');
    this.getDictionary('bas_role_type,bas_org_type', (data) => {
      this.userInfo = this.$store.state.userInfo;
      this.dicMap.bas_role_type = this.dicListToMap(data.bas_role_type);
      this.dicMap.bas_org_type = this.dicListToMap(data.bas_org_type);
      this.isAdmin = this.userInfo.isAdmin && this.userInfo.bizType === this.dicMap.bas_org_type.platform;
      this.getRoleList();
    });
  },
  methods: {
    // 字典列表转为map{code, value}
    dicListToMap(list) {
      const map = {};
      list.forEach((item) => {
        map[item.code] = item.value;
      });
      return map;
    },
    // 获取系统自定义岗位
    getSysRole() {
      this.$getJSON(apis.UserRoleAll, {
        orgId: this.orgId,
        isOwnOrgan: 0,
        isShowNotice: 1,
        isShowService: 1,
      }).then((res) => {
        this.sysRoleList = res.data;
      });
    },

    // 获取岗位列表
    getRoleList: function () {
      this.$getJSON(apis.UserRoleAll, {
        orgId: this.orgId,
        isOwnOrgan: 1,
        isShowNotice: 1,
        isShowService: 1,
      }).then((res) => {
        const roleList = [];
        const sysRoleList = [];
        const map = this.dicMap.bas_role_type;
        // 服务角色，通知角色
        const arr = [map.notice_role, map.service_role];
        if (!this.isAdmin) {
          res.data.forEach((item) => {
            if (arr.includes(item.roleType)) {
              sysRoleList.push(item);
            } else {
              roleList.push(item);
            }
          });
        } else {
          roleList.push(...res.data);
        }

        this.roleList = roleList;
        this.sysRoleList = sysRoleList;
        if (!this.roleData.roleId) {
          this.roleData = this.roleList[0] ? this.roleList[0] : {};
        }
        this.$nextTick(() => {
          if (this.roleData.roleId) {
            this.$refs.tree.setCurrentKey(this.roleData.roleId);
          }
        });
      });
    },
    // 选中角色项
    handleNodeClick: function (row) {
      const map = this.dicMap.bas_role_type;
      const oldRoleType = this.roleData.roleType;
      const newRoleType = row.roleType;
      const arr = [map.notice_role, map.service_role];

      if (!this.isAdmin) {
        // 自定义角色（服务角色，通知角色）
        if (arr.includes(newRoleType)) {
          this.$refs.tree.setCurrentKey(null);
          if (!arr.includes(oldRoleType) || oldRoleType !== newRoleType) {
            this.activeTab = 'employeeList';
          }
        } else {
          this.$refs.tree2.setCurrentKey(null);
          if (arr.includes(oldRoleType)) {
            this.activeTab = 'funcRole';
          }
        }
        // if (oldRoleType !== newRoleType) {
        //   // 因为不同的roleType tabData不同，故要根据不同roleType判断tabIndex
        //   if ((!arr.includes(oldRoleType) && newRoleType === map.notice_role) || (oldRoleType === map.service_role && newRoleType === map.notice_role)) {
        //     this.activeTab = 'employeeList';
        //   } else {
        //     this.activeTab = 'funcRole';
        //   }
        // }
      }
      this.roleData = row;
    },
    // 搜索过滤事件
    filterTree: function () {
      this.$refs.tree.filter(this.appKey);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.roleName.indexOf(value) !== -1;
    },
    // 新增岗位
    addRole: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_role.xin_zeng_gang_wei');
      this.dialogModel.orgId = this.orgId;
      this.dialogVisible = true;
    },
    // 编辑岗位
    editRole: function (data) {
      this.dialogModel = data;
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_role.bian_ji_gang_wei');

      this.dialogVisible = true;
    },
    // 删除岗位
    deleteRole: function (data) {
      this.$showConfirm(this.$t('base_role.nqdyscxzdgwm')).then(() => {
        this.$postJSON(`${apis.RoleDelete}/${data.roleId}`).then(() => {
          this.getRoleList();
        });
      });
    },
    // 禁止/启用岗位
    changeStateRole: function (data) {
      this.$showConfirm(data.state === 0 ? this.$t('base_role.nqdyqyxzdgwm') : this.$t('base_role.nqdyjyxzdgwm')).then(() => {
        this.$postJSON(apis.RoleState, {
          roleId: data.roleId,
          state: data.state === 0 ? 1 : 0,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getRoleList();
        });
      });
    },

    dragStart(event) {
      if (!event.target.className.includes('drag')) {
        return;
      }
      const startY = event.clientY;
      const moveY = startY;
      const container = document.querySelector('#sys-user');
      this.startY = startY;
      this.moveY = moveY;
      this.containerH = container.clientHeight;
      this.hasDrag = true;
    },
    dragMove(event) {
      if (!this.hasDrag) {
        return;
      }
      this.moveY = event.clientY;
    },
    dragEnd() {
      this.hasDrag = false;
      this.containerH = this.containerH + this.startY - this.moveY;
      this.startY = 0;
      this.moveY = 0;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.role-bd {
  height: 100%;
  padding: 16px;
  position: relative;
  &.crm-role {
    padding: 0;
  }
  & > .aside {
    position: absolute;
    box-shadow: 0.5px 0px 3px 0px rgba(51, 51, 51, 0.12);
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #ffffff;
    overflow: auto;
    .title {
      padding: 0 10px;
      line-height: 70px;
      color: #394668;
      font-weight: bold;
      font-size: 15px;
      .icon {
        float: left;
        font-size: 14px;
        margin-right: 8px;
        font-weight: normal;
        @include color_main();
      }
    }
    .search {
      margin: 0 10px 16px;
    }
    .list {
      .el-tree-node__content > .el-tree-node__expand-icon {
        display: none;
      }
      .el-tree-node__content .tree-item {
        padding-left: 10px;
      }
    }
    .list,
    .tree {
      flex: 1;
      margin: 0 10px;
      overflow-y: auto;
      .el-tree-node__content {
        line-height: 32px;
        height: 32px;
        &:hover {
          background-color: #f8f9fb;
        }
      }
      .el-tree-node__content > .el-tree-node__expand-icon {
        color: #495057;
        &.is-leaf {
          color: transparent;
        }
      }
      .is-current > .el-tree-node__content {
        background-color: #eef2f8 !important;
        .tree-item {
          @include color_main();
          .icon {
            @include color_main();
            font-size: 12px;
          }
          .disable {
            color: rgba(108, 117, 125, 0.5);
          }
        }
      }
      .tree-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        padding-right: 10px;
        overflow: hidden;
        color: #6c757d;
        .disable {
          color: rgba(108, 117, 125, 0.5);
        }
      }
    }
  }
  & > .section {
    height: 100%;
    margin-left: 240px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 0 16px;
    &.padding0 {
      padding: 0;
    }
    .section-info {
      padding-top: 16px;
      table {
        width: 100%;
      }
      table tr {
        height: 44px;
        line-height: 44px;
        text-align: left;
        th {
          padding: 0 10px;
          font-size: 12px;
          color: #636e78;
          background-color: #f2f3fb;
        }
        td {
          padding: 0 10px;
          color: #6c757d;
          font-size: 12px;
          border-bottom: 1px solid #eef2f8;
        }
      }
    }
    .table-bd {
      flex: 1;
      height: 0;
    }
  }

  .aside {
    overflow: hidden;
  }
  .org-role {
    overflow: hidden;
  }
  .sys-user {
    display: flex;
    flex-direction: column;

    .bar {
      cursor: ns-resize;
      position: relative;
      height: 10px;
      text-align: center;
      @include background_color_main();
      .bar-box {
        width: 16px;
        div {
          height: 1px;
          background-color: rgba(255, 255, 255, 0.66);
        }
        div:first-child {
          margin-bottom: 2.5px;
        }
      }
    }
  }
}
</style>
